import { ReducerFunctions } from "../../utils";
import {
  CreateDisputeComments,
  CreateDisputes,
  DisputeComments,
  Disputes,
  ShowDisputes,
  UpdateDisputes,
} from "./disputes";

// Reducers for Disputes
export const disputes_reducer = ReducerFunctions(Disputes, {});
export const show_dispute_reducer = ReducerFunctions(ShowDisputes, {});
export const create_disputes_reducer = ReducerFunctions(CreateDisputes, {});

// Reducer for UpdateDisputes
export const update_disputes_reducer = ReducerFunctions(UpdateDisputes, {});

// Reducers for DisputeComments
export const dispute_comments_reducer = ReducerFunctions(DisputeComments, {});
export const create_dispute_comments_reducer = ReducerFunctions(
  CreateDisputeComments,
  {}
);
